import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {FailRootState as RootState} from '../../interfaces'
import common from '../../slices/common'

const createRootReducer = (): Reducer<RootState> =>
    combineReducers({
        common,
        router: routerReducer,
    })

export default createRootReducer
